module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$slots.default) ? _c('div', {
    staticClass: "rt-stateline-item__content",
    class: ['is-' + _vm.status]
  }, [_c('div', {
    staticClass: "rt-stateline-item__icon rt-stateline-item__content__icon",
    style: (_vm.iconStyle)
  }, [_vm._t("icon", function() {
    return [(_vm.status) ? _c('rt-icon', {
      attrs: {
        "name": _vm.iconName,
        "size": 14
      }
    }) : _vm._e()]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "rt-stateline-item__description"
  }, [_vm._t("default")], 2)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ecffce64"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/stateline/rtStatelineContent.vue
// module id = 2234
// module chunks = 137